import { default as enrichmentDictionaryJson } from '@modules/directoryTopics/constants/enrichmentDictionary.json'

export type EnrichmentDictionaryEntry = {
  keyword: string
  links: EnrichmentDictionaryLink[]
  matcher: RegExp
  slug: string
}

export type EnrichmentDictionaryLink = {
  label: string
  url: string
}

/**
 * Given a directory topic slug, return a dictionary of labelled links. Uses a lazy loaded
 * dictionary that is generated in memory from a file on disk on first invocation.
 *
 * @param slug Directory topic slug
 */
export function getDirectoryTopicEnrichment(
  slug: string,
): EnrichmentDictionaryEntry | undefined {
  return getEnrichmentDictionary().get(slug)
}

// Lazy loaded dictionary generated in memory on first invocation
const enrichmentDictionary: Map<string, EnrichmentDictionaryEntry> = new Map()

/**
 * Lazy load a dictionary of terms with labelled links to match entities
 */
export default function getEnrichmentDictionary(): Map<
  string,
  EnrichmentDictionaryEntry
> {
  if (enrichmentDictionary.size > 0) {
    return enrichmentDictionary
  }

  for (const record of enrichmentDictionaryJson.records) {
    const { keyword, links, slug } = record
    const matcher = new RegExp(`\\b${keyword}\\b`, 'i')
    enrichmentDictionary.set(slug, { keyword, links, matcher, slug })
  }

  return enrichmentDictionary
}
